import React from 'react'
import Card from '../shared/card/card.jsx'
import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'


export default React.createClass({

  render: function(){
    let taskpath = getTaskTypeIconParser(this.props.task.taskType).iconsrc;
    return (
      <Card
        btnText='See Details'
        additionalClasses='task-card'
        headerHidden={true}
        cardSmallHeaderImage={taskpath + '-detail.png'}
        cardSmallHeaderIcon={taskpath}
        cardBottomPadding={18}
        btnOnClick={() => this.props.openEditTaskModal(this.props.task)}
        btnId={'task' + this.props.btnId}
        btnStyle='btn btn-info btn-sm cerulean-blue-background center-block task-button'>
        <div className='text-center task-card-body'>
          <p className={taskpath + '-color'} style={{fontSize: 25, marginBottom: 0}}>{getTaskTypeIconParser(this.props.task.taskType).prettify}</p>
          <p style={{fontWeight: 'bold', fontSize: 17, color: '#5c5c5c'}} className='hidden-xs'>{this.props.task.taskDescription}</p>
          <p style={{fontWeight: 'bold', fontSize: 14, color: '#5c5c5c'}} className='visible-xs'>{this.props.task.taskDescription}</p>
        </div>
      </Card>
    )}
})


// WEBPACK FOOTER //
// ./src/components/account/my-task-card.jsx